import { render } from "./NewsCard.vue?vue&type=template&id=2143d8f9&scoped=true&lang=pug"
import script from "./NewsCard.vue?vue&type=script&lang=ts"
export * from "./NewsCard.vue?vue&type=script&lang=ts"

import "./NewsCard.vue?vue&type=style&index=0&id=2143d8f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2143d8f9"

export default script